import { Box } from '@mui/material';
import { DpdFooter } from '@dpdgroupuk/cc-dpd-ui';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import configSlice from '../../redux/configSlice';
import useBreakpoint from '../../hooks/useBreakpoint';
import {
  DONT_HAVE_ACCESS,
  HOME,
  NOT_FOUND,
  PICKUP_FINDER,
  PROFILE,
  SIGN_IN,
  SIGN_UP,
} from '../../constants/routes';
import { USER_PREFERENCES_MOBILE_MENU_FIXED_HEIGHT } from '../../constants/gaps';

const forbiddenPages = [
  PICKUP_FINDER,
  PROFILE,
  NOT_FOUND,
  DONT_HAVE_ACCESS,
  SIGN_IN,
  SIGN_UP,
];

export default function Footer() {
  const { pathname: currentPath } = useLocation();
  const isSmallScreen = useBreakpoint('md');
  const { terms: termsLink } = useSelector(
    configSlice.selectors.getLinksConfig
  );

  const isFooterUnavailable = forbiddenPages.some(page =>
    currentPath.includes(page)
  );
  const hasBottomGap = currentPath.includes(PROFILE) && isSmallScreen;
  const isHomePage = currentPath === HOME;

  if (isFooterUnavailable) return null;

  const openPrivacyCenter = () => {
    if (typeof window.__cmp === 'function') {
      window.__cmp('showScreen');
    }
  };

  const links = [
    termsLink
      ? { id: 'terms', label: 'Terms & Conditions', href: termsLink }
      : 'terms',
    'privacy',
    { id: 'cookie', label: 'Cookie Policy', onClick: openPrivacyCenter },
    'cyber',
    'disabledPolicy',
    'fuelSurcharge',
    'geopost',
  ];

  return (
    <Box
      sx={{
        mb: hasBottomGap ? USER_PREFERENCES_MOBILE_MENU_FIXED_HEIGHT : 0,
        // Extra bottom padding on mobile to clear floating UI (chat widget etc.)
        '& > div': {
          pb: { xs: isHomePage ? 15 : 10, md: 8 },
        },
      }}
    >
      <DpdFooter showPaymentSection links={links} />
    </Box>
  );
}
